import { toast } from "react-hot-toast";
import { Snackbar } from "@/components/atoms";

export interface SnackbarConfig {
  title?: string;
  message: string;
  actionText?: string;
  onActionClick?: () => void;
  timestamp?: string;
  icon?: React.ReactNode;
  size?: "default" | "small";
  textMode?: "single" | "multiple";
  duration?: number;
}

export const showSnackbar = (config: SnackbarConfig) => {
  const {
    title,
    message,
    actionText,
    onActionClick,
    timestamp,
    icon,
    size = "default",
    textMode = "single",
    duration = 8000, // Longer duration for snackbars since they typically contain more info
  } = config;

  const { innerWidth: width } = window;

  const handleActionClick = () => {
    if (onActionClick) {
      onActionClick();
    }
    // Auto-dismiss the snackbar when action is clicked
    toast.dismiss();
  };

  toast.custom(
    (t) => (
      <Snackbar
        size={size}
        textMode={textMode}
        title={title}
        message={message}
        actionText={actionText}
        onActionClick={actionText ? handleActionClick : undefined}
        timestamp={timestamp}
        icon={icon}
        visible={t.visible}
        onClose={() => toast.dismiss(t.id)}
      />
    ),
    {
      position: width > 768 ? "bottom-right" : "bottom-center",
      duration,
    }
  );
};

